import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { updateAccountOpenpay } from "../../../../graphql/myMutations";

var kys = require("./envscomercial.json");
var Openpay = require("openpay");

function UseOpenpay() {

  var openpay = new Openpay(
    kys.chargeIdOpp,
    kys.apikeyPrivadaOpp,
    false
  );
  function createClient(obj, fn) {
    openpay.customers.create(obj, fn);
  }
  function createCardtoClient(id, obj, callback) {
    openpay.customers.cards.create(id, obj, callback);
  }
  function createCLABE(customerId,bankaccountRequest, callback){
    openpay.customers.bankaccounts.create(customerId, bankaccountRequest, callback);
  }
  function getCLABE(customerId, bankaccountId, callback){
    openpay.customers.bankaccounts.get(customerId, bankaccountId, callback);
  }
  function getCARD(customerId, cardId, callback){
    openpay.customers.cards.get(customerId, cardId, callback);
  }
  async function updatebd(idpen, method, idcard, bdid,clabe) {
    //*Este es el obj que se mandará a la bd en el campo de openpay id
    const dataopp = {
      openPay_id: idpen,
      method: method,
      idcard: idcard,
      idclabe:clabe
    };

    const openpayobj = {
      id: bdid,
      openPay_id: JSON.stringify(dataopp),
    };

    try {
      const result = await API.graphql(
        graphqlOperation(updateAccountOpenpay, { input: openpayobj })
      );
      console.log("Se agrego exitosamente el id de open pay", result);

    } catch (err) {
      console.log(err, "Hubo un error al agregar Tarjeta");
    }
  }

  /**
 *
 * @param {string} string string number credit card
 * @returns {string} formatted Credit Card Number
 */
 const formattedCardNumber = (string) => {

  let block_1 = string.slice(0, 4);
  let block_2 = string.slice(4, 8);
  let block_3 = string.slice(8, 12);
  let block_4 = string.slice(12, 16);
  let block_5 = string.slice(16, 20);

  block_1 = block_1 === "" ? "" : `${block_1}`;
  block_2 = block_2 === "" ? "" : ` ${block_2}`;
  block_3 = block_3 === "" ? "" : ` ${block_3}`;
  block_4 = block_4 === "" ? "" : ` ${block_4}`;
  block_5 = block_5 === "" ? "" : ` ${block_5}`;

  const stringFormated = `${block_1}${block_2}${block_3}${block_4}${block_5}`

  return stringFormated;
}


  return { createClient, createCardtoClient, updatebd ,formattedCardNumber,createCLABE,getCLABE,getCARD,};
}

export default UseOpenpay;
